import { useEffect } from 'react';
import { RMC_ASSISTANT_DRAWER } from 'src/constants/featureFlags';
import { useFeatureFlags } from 'src/routes/featureFlagsContext';
import { useAssistantDrawer } from 'src/routes/ClientDashboard/components/AssistantDrawerContext';

const isEditableTarget = (el: EventTarget | null): boolean => {
  const node = el as HTMLElement | null;
  if (!node) return false;
  const tag = node.tagName;
  return (
    tag === 'INPUT' ||
    tag === 'TEXTAREA' ||
    (node as any).isContentEditable === true
  );
};

export const useAssistantDrawerShortcut = () => {
  const { featureFlags } = useFeatureFlags();
  const enabled = featureFlags.includes(RMC_ASSISTANT_DRAWER);
  const { toggle, isEnabled } = useAssistantDrawer();

  useEffect(() => {
    if (!enabled || !isEnabled) return;

    const onKeyDown = (e: KeyboardEvent) => {
      // For the toggle chord we still ignore editable targets to avoid interrupting typing
      if (isEditableTarget(e.target)) return;
      // Toggle on Cmd+K (mac) or Ctrl+K (fallback)
      const isK = e.key?.toLowerCase() === 'k';
      const isToggleChord = isK && (e.metaKey || e.ctrlKey) && !e.altKey && !e.shiftKey;
      if (isToggleChord) {
        e.preventDefault();
        toggle();
        return;
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [enabled, isEnabled, toggle]);

  return { isEnabled: enabled && isEnabled };
};
